import { AppBar, Container, Toolbar, Typography } from "@material-ui/core";
import React from "react";

const Header = ({ projectName, clientName }) => {
  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar>
          <Typography variant="h6">
            {projectName} - {clientName}
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
